/**
 * Styling Settings Component Export
 *
 * @since 1.0.0
 */

export { StylingSettings } from './component';
export type { StylingSettingsData, StylingSettingsProps } from './types';
